const TYPE = 'ps.StoreTraffic'

function create() {
  return {
    type : TYPE
  }
}
export default {
  TYPE,
  create
}
